// extracted by mini-css-extract-plugin
export default {"header":"Header_header__stqK6","logo":"Header_logo__uTM2S","button":"Header_button__dE8KM","buttonMobile":"Header_buttonMobile__DSD2Q","burger":"Header_burger__HRaZ5"};